/**
 * Initial limit for MessageArea's active `useQuery`
 * (`messages.byChannelComposite`). Distinct from the workspace
 * preload's per-channel limit (`PRELOAD_MESSAGES_PER_CHANNEL` in
 * `@ano/shared/queries`) — the preload covers the visible viewport
 * for instant first paint; the active query fills deeper history +
 * rich joins (reactions, attachments, link previews, etc.).
 *
 * The two queries have different identities (workspace-rooted vs
 * channel-rooted), so Zero materializes them independently — but
 * the per-channel sort order matches, so Zero's prefix guarantee
 * holds: locally-cached preload rows render immediately under the
 * active query.
 *
 * See: https://zero.rocicorp.dev/docs/queries#consistency
 */
export const MESSAGE_PAGE_SIZE = 300;
